export function parseJsonWithDefault(data: string, fallback: unknown) {
  try {
    // NOTE: The OR here is needed because if data is null it will not trigger the catch.
    return JSON.parse(data) || fallback;
  } catch (e) {
    return fallback;
  }
}
